import { Action } from '@ngrx/store'

import { ErpOrder } from '../models/orderline';
import { ApiOrder } from '../../cart/models/cart-models'
import { RequestWrap } from '../../core/models/request-wrap';

export const ADD = '[Order] Add'

export const LOAD = '[Order] Load'
export const LOAD_SUCCESS = '[Order] Load Success'
export const LOAD_FAILED = '[Order] Load Failed'

export const EXPAND = '[Order] Expand'
export const EXPAND_SUCCESS = '[Order] Expand Success'
export const EXPAND_FAILED = '[Order] Expand Failed'

export class Add implements Action {
    readonly type = ADD
    constructor(public payload: ApiOrder) {}
}

export class Load implements Action {
    readonly type = LOAD
}

export class LoadSuccess implements Action {
    readonly type = LOAD_SUCCESS

    constructor(public payload: RequestWrap<ErpOrder[]>) {}
}

export class LoadFailed implements Action {
    readonly type = LOAD_FAILED

    constructor(public payload: any) {}
}

export class Expand implements Action {
    readonly type = EXPAND
}

export class ExpandSuccess implements Action {
    readonly type = EXPAND_SUCCESS
    constructor(public payload: RequestWrap<ErpOrder[]>) {}
}

export class ExpandFailed implements Action {
    readonly type = EXPAND_FAILED
    constructor(public payload: any) {}
}

export type Actions =
    Add
    | Load
    | LoadSuccess
    | LoadFailed
    | Expand
    | ExpandSuccess
    | ExpandFailed
